import { EventRouter } from '@deqo/podopolis';
import { injectable } from 'inversify';
import { Point } from '../../../platform/geom/Point';

export type Slap = readonly [string, Point, number];

@injectable()
export class SlapRelay extends EventRouter<{ slap: Slap }> {
}
